export function setLoading(state, loading) {
    state.loading = loading
}
export function setAccountReportResultEri(state, account_report){
    state.account_report = account_report
}
export function setMontsFields(state, monts_fields){
    state.monts_fields = monts_fields
}

export function setcost_center_1 (state, cost_center_1){
    state.cost_center_1 = cost_center_1
}


// WEBPACK FOOTER //
// ./src/modules/report-reult-eri/mutations.js